import React, { useState } from "react";
import { Link } from "react-router-dom"; // Asegúrate de importar Link
import "../../css/Header/header.css";
import TelefonosUtiles from "../pages/NuestraCiudad/TelefonosUtiles";

const menuItems = [
  {
    label: "Trámites",
    submenu: [
      { label: "Licencia de Conducir", href: "/tramites/licencia-de-conducir" },
      {
        label: "Turno de Castraciones",
        href: "https://docs.google.com/forms/d/e/1FAIpQLSe8yM5rZ_rauQXVyWAKN8OnAzWP5t7-7Bc3OiwWIeKBvNHBDQ/closedform",
      },
      {
        label: "Programa Empleo",
        href: "https://odi.ciudaddeoliva.gov.ar/odi/",
      },
      {
        label: "Registro de Proveedores",
        href: "https://odi.ciudaddeoliva.gov.ar/odi/",
      },
      {
        label: "Habilitación Comercial Industrial / Servicios Online",
        href: "https://docs.google.com/forms/d/e/1FAIpQLSdykVeMb_eGeAXLkfVAwfE-CtrM48l9-Oo9XyxsKHnOg6B1Ew/viewform",
      },
      {
        label: "Carnet de Manipulación de Alimentos",
        href: "/tramites/manipulador-alimentos",
      },{
        label: "Apto Edilicio",
        href: "http://ciudaddeoliva.gov.ar/file/pdf/web-oliva/INFORME-TECNICO-APTO-EDILICIO.pdf",
      },
    ],
  },
  {
    label: "Transparencia",
    submenu: [
      {
        label: "Pedido de Información Pública",
        href: "/informacion-publica",
      },
      {
        label: "DDJJ de Funcionarios Públicos",
        href: "/declaracion-jurada",
      },
      {
        label: "Presupuesto Participativo",
        href: "/presupuesto-participativo",
      },
      {
        label: "Memoria Descriptiva",
        href: "/memoria-descriptiva",
      },
      {
        label: "Listado del Personal",
        href: "https://ciudaddeoliva.gov.ar/file/pdf/web-oliva/lista-empleados/listado-empleados.pdf",
      },
      {
        label: "Escala Salarial de Empleado Municipales",
        href: "https://ciudaddeoliva.gov.ar/file/pdf/web-oliva/escala-salarial/escala-salarial.pdf",
      },
      {
        label: "Ejecución Presupuestaria",
        href: "/transparencia/ejecucion-presupuestaria",
      },
    ],
  },
  {
    label: "Boletín Oficial",
    submenu: [
      {
        label: "Ordenanzas",
        href: "/ordenanzas",
      },
      {
        label: "Decretos",
        href: "/decretos",
      },
      {
        label: "Resoluciones Individuales",
        href: "/resoluciones-individuales",
      },
      {
        label: "Defensor del Vecino",
        href: "/defensor-vecino",
      },
      {
        label: "Edictos",
        href: "/edictos",
      },
      {
        label: "Declaraciones",
        href: "/declaraciones",
      },
      {
        label: "Resoluciones Generales",
        href: "/resoluciones-generales",
      },
      {
        label: "Resoluciones JEM",
        href: "/resoluciones-junta-electoral-municipal",
      },
    ],
  },
  {
    label: "Nuestra Ciudad",
    submenu: [
      {
        label: "Historia",
        href: "/historia",
      },
      {
        label: "Museo de Oliva Virtual",
        href: "https://ciudaddeoliva.gob.ar/movi/",
      },
      {
        label: "Hermanamiento San Pietro Val Lemina",
        href: "https://ciudaddeoliva.gov.ar/file/pdf/web-oliva/Hermanamiento.pdf",
      },
      {
        label: "Registro de Podadores",
        href: "https://ciudaddeoliva.gob.ar/pdf/registro-podadores.pdf",
      },
      {
        label: "Mapa Oficial Digital",
        href: "https://qgiscloud.com/ciudaddeoliva/SIG_OLIVA_WEB/",
      },
      {
        label: "Símbolos Patrios",
        href: "https://ciudaddeoliva.gov.ar/file/pdf/web-oliva/GUIA-EDUCATIVA-OLIVA-2021.pdf",
      },
      {
        label: "Código de Edificación",
        href: "https://ciudaddeoliva.gov.ar/sys/file/ordenanzas/202381513667.pdf",
      },
      {
        label: "Plan Local de Acción Climática",
        href: "/plan-local-de-accion-climatica",
      },
    ],
  },
  {
    label: "Área de Gobierno",
    submenu: [
      {
        label: "Ejecutivo",
        href: "/ejecutivo",
      },
      {
        label: "Concejo Deliberante",
        href: "/concejo-deliberante",
      },
      {
        label: "Tribunal de Cuentas",
        href: "/tribunal-de-cuentas",
      },
      {
        label: "Organigrama",
        href: "/organigrama",
      },
    ],
  },
  {
    label: "Convención Municipal",
    submenu: [
      {
        label: "Proyectos Presentados",
        href: "/proyectos-presentados",
      },
      {
        label: "Despacho de Comisión",
        href: "/despacho-comision",
      },
      {
        label: "Actas de Sesiones Ordinarias",
        href: "/actas-sesiones",
      },
      {
        label: "Carta Orgánica",
        href: "https://ciudaddeoliva.gov.ar/file/pdf/web-oliva/CARTA-ORGANICA.pdf",
      },
      {
        label: "Carta Orgánica Accesible",
        href: "https://drive.google.com/drive/folders/1YiNVg8Am9Bpnvt-5pJ3_6oainPQ2c6H7?fbclid=IwAR0zsv_GSp1XCFjvgITZqwgBrsq-GXCJmivg-Bzd5SlscmdlUUL0BV5MX34",
      },
    ],
  },
];

const isExternal = (url) => /^https?:\/\//.test(url);

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [openSubmenu, setOpenSubmenu] = useState(null);

  const handleMenuToggle = () => {
    setMenuOpen(!menuOpen);
    setOpenSubmenu(null); // Cierra submenús al abrir/cerrar menú principal
  };

  const handleSubmenuToggle = (idx) => {
    if (openSubmenu === idx) {
      setOpenSubmenu(null);
    } else {
      setOpenSubmenu(idx);
    }
  };

  // Cierra menú al hacer click en un enlace (solo móvil)
  const handleLinkClick = () => {
    if (window.innerWidth <= 800) {
      setMenuOpen(false);
      setOpenSubmenu(null);
    }
  };

  return (
    <nav className="header-nav">
      <div className="header-container">
        <Link to="/" className="logo-link">
        <img
          src={require("../img/oliva-logo.png")}
          alt="Oliva Logo"
          className="logoHeader"
        />
        </Link>
        <button className="menu-toggle" onClick={handleMenuToggle}>
          <span className="hamburger"></span>
          <span className="hamburger"></span>
          <span className="hamburger"></span>
        </button>
        <ul className={`nav-list ${menuOpen ? "open" : ""}`}>
          <li className="nav-item">
            <Link className="nav-link" to="/" onClick={handleLinkClick}>
              Inicio
            </Link>
          </li>
          {/* Trámites */}
          <li
            className={`nav-item ${menuItems[0].submenu ? "has-submenu" : ""} ${
              openSubmenu === 0 ? "submenu-open" : ""
            }`}
            key={menuItems[0].label}
            onMouseEnter={() => {
              if (menuItems[0].disabled) return;
              if (window.innerWidth > 800) setOpenSubmenu(0);
            }}
            onMouseLeave={() => {
              if (menuItems[0].disabled) return;
              if (window.innerWidth > 800) setOpenSubmenu(null);
            }}
          >
            <button
              className={`nav-link${menuItems[0].disabled ? " disabled" : ""}`}
              type="button"
              onClick={(e) => {
                if (menuItems[0].disabled) return;
                if (window.innerWidth <= 800) {
                  e.preventDefault();
                  handleSubmenuToggle(0);
                }
              }}
              disabled={menuItems[0].disabled}
              tabIndex={menuItems[0].disabled ? -1 : 0}
            >
              {menuItems[0].label}
            </button>
            {menuItems[0].submenu && (
              <ul
                className={`submenu ${
                  (window.innerWidth > 800 && openSubmenu === 0) ||
                  (window.innerWidth <= 800 && openSubmenu === 0)
                    ? "show"
                    : ""
                }`}
              >
                {menuItems[0].submenu.map((sub, subIdx) => (
                  <li key={subIdx}>
                    {sub.disabled ? (
                      <span className="submenu-link disabled">
                        {sub.label}
                      </span>
                    ) : isExternal(sub.href) ? (
                      <a
                        href={sub.href}
                        className="submenu-link"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={handleLinkClick}
                      >
                        {sub.label}
                      </a>
                    ) : (
                      <Link
                        to={sub.href}
                        className="submenu-link"
                        onClick={handleLinkClick}
                      >
                        {sub.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            )}
          </li>
          {/* Botón Turismo */}
          <li className="nav-item">
            <Link
              className="nav-link"
              to="/turismo"
              onClick={handleLinkClick}
            >
              Turismo
            </Link>
          </li>
          {/* El resto del menú */}
          {menuItems.slice(1).map((item, idx) => (
            <li
              className={`nav-item ${item.submenu ? "has-submenu" : ""} ${
                openSubmenu === idx + 1 ? "submenu-open" : ""
              }`}
              key={item.label}
              onMouseEnter={() => {
                if (item.disabled) return;
                if (window.innerWidth > 800) setOpenSubmenu(idx + 1);
              }}
              onMouseLeave={() => {
                if (item.disabled) return;
                if (window.innerWidth > 800) setOpenSubmenu(null);
              }}
            >
              <button
                className={`nav-link${item.disabled ? " disabled" : ""}`}
                type="button"
                onClick={(e) => {
                  if (item.disabled) return;
                  if (window.innerWidth <= 800) {
                    e.preventDefault();
                    handleSubmenuToggle(idx + 1);
                  }
                }}
                disabled={item.disabled}
                tabIndex={item.disabled ? -1 : 0}
              >
                {item.label}
              </button>
              {item.submenu && (
                <ul
                  className={`submenu ${
                    (window.innerWidth > 800 && openSubmenu === idx + 1) ||
                    (window.innerWidth <= 800 && openSubmenu === idx + 1)
                      ? "show"
                      : ""
                  }`}
                >
                  {item.submenu.map((sub, subIdx) => (
                    <li key={subIdx}>
                      {sub.disabled ? (
                        <span className="submenu-link disabled">
                          {sub.label}
                        </span>
                      ) : isExternal(sub.href) ? (
                        <a
                          href={sub.href}
                          className="submenu-link"
                          target="_blank"
                          rel="noopener noreferrer"
                          onClick={handleLinkClick}
                        >
                          {sub.label}
                        </a>
                      ) : (
                        <Link
                          to={sub.href}
                          className="submenu-link"
                          onClick={handleLinkClick}
                        >
                          {sub.label}
                        </Link>
                      )}
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
      </div>
      <TelefonosUtiles />
    </nav>
  );
};

export default Header;
